import { combineReducers } from 'redux';
import { normalizeAPIError } from '../../errors';

const modals = (
  state = {
    activeModal: null,
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ...state,
        activeModal: action.id,
      };
    case 'HIDE_MODAL':
      return {
        ...state,
        activeModal: null,
      };
    case 'TOGGLE_MODAL':
      const toggleValue = state.activeModal === action.id ? null : action.id;
      return {
        ...state,
        activeModal: toggleValue,
      };
    default:
      return state;
  }
};

const confirmationDialog = (
  state = {
    activeDialog: null,
    response: null,
    settings: null,
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_CONFIRMATION_DIALOG':
      return {
        ...state,
        activeDialog: action.name,
        settings: action.settings,
      };
    case 'CLEAR_CONFIRMATION_DIALOG':
      return {
        activeDialog: null,
        response: null,
        settings: null,
      };
    case 'RESPOND_TO_CONFIRMATION_DIALOG':
      return {
        ...state,
        response: action.response,
      };
    default:
      return state;
  }
};

const pageErrors = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_PAGE_ERROR':
      return {
        ...state,
        [action.route]: action.error,
      };
    case 'CLEAR_PAGE_ERROR':
      const clearedState = { ...state };
      delete clearedState[action.route];
      return clearedState;
    default:
      return state;
  }
};

const messages = (state = {}, action) => {
  switch (action.type) {
    case 'CHANGE_EMAIL_SUBSCRIPTIONS_REQUEST':
      return {
        ...state,
        email_subscription: {
          type: 'info',
          msgId: 'email_subscription.update_message',
        },
      };
    case 'CHANGE_EMAIL_SUBSCRIPTIONS_FAILURE':
      return {
        ...state,
        email_subscription: {
          ...normalizeAPIError(action.error, action.type),
          errorCode: action.error.errorCode,
        },
      };
    case 'CHANGE_EMAIL_SUBSCRIPTIONS_SUCCESS':
      return {
        ...state,
        email_subscription: {
          type: 'success',
          msgId: 'email_subscription.unsubscribe_message',
        },
      };
    case 'ADD_PAGE_ERROR':
      return {
        ...state,
        [action.route]: action.error,
      };
    case 'CLEAR_PAGE_ERROR':
      const clearedState = { ...state };
      delete clearedState[action.route];
      return clearedState;
    default:
      return state;
  }
};

const ui = combineReducers({
  modals,
  confirmationDialog,
  pageErrors,
  messages,
});

export default ui;
export const isModalActive = (state, id) => state.modals.activeModal === id;
export const isConfirmationDialogActive = (state, name) =>
  state.confirmationDialog.activeDialog === name;
export const getPageError = (state, route) => state.pageErrors[route];
export const getMessage = (state, id) => state.messages[id] || null;
export const getConfirmationDialog = (state, name) => {
  if (!isConfirmationDialogActive(state, name)) return null;
  return {
    ...state.confirmationDialog,
    name,
  };
};
